/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function lucieFixEmptyCart() {
  const emptyMessage = document.querySelector('.drawer__empty__message');

  if (emptyMessage) {
    emptyMessage.textContent = 'Votre panier est vide.';
  }
}

lucieFixEmptyCart();

document.addEventListener('theme:cart-drawer:show', function() {
  setTimeout(lucieFixEmptyCart, 50);
  setTimeout(lucieFixEmptyCart, 250);
});

document.addEventListener('theme:cart:change', function() {
  setTimeout(lucieFixEmptyCart, 100);
});

const lucieCartObserver = new MutationObserver(function() {
  lucieFixEmptyCart();
});

lucieCartObserver.observe(document.body, {
  childList: true,
  subtree: true
});

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
